export const manifest = {
  screens: {
    scr_8fvpid: { name: "Overview", route: "/", state: {"currentView":"overview"}, position: {"x":160,"y":220} },
    scr_589i4e: { name: "BPS Rate Tables", route: "/", state: {"currentView":"rate-tables"}, position: {"x":1560,"y":220} },
    scr_t82s1o: { name: "CDS Tiers", route: "/", state: {"currentView":"cds-tiers"}, position: {"x":2960,"y":220} },
    scr_yi1tw2: { name: "Draws", route: "/", state: {"currentView":"draws"}, position: {"x":4360,"y":220} },
    scr_mvi3tv: { name: "Fees & Recoupments", route: "/", state: {"currentView":"fees"}, position: {"x":7160,"y":220} },
    scr_q8kfc6: { name: "LO View", route: "/", state: {"currentView":"lo-view"}, position: {"x":5760,"y":220} },
  },
  sections: {
    sec_3tko5e: { name: "Main Dashboard Views", x: 0, y: 0, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_3tko5e", children: [
      { kind: "screen", id: "scr_8fvpid" },
      { kind: "screen", id: "scr_589i4e" },
      { kind: "screen", id: "scr_t82s1o" },
      { kind: "screen", id: "scr_yi1tw2" },
      { kind: "screen", id: "scr_q8kfc6" },
      { kind: "screen", id: "scr_mvi3tv" },
    ] },
  ],
}
